import styled from "styled-components";
import { colors } from "../../../theme/colors";
import _ from "lodash";
import { Spacer } from "../../../components/ui/spacer/spacer.component";
import { useState } from "react";

export const CastView = ({
  name,
  description,
  image,
}: {
  name: string;
  description: string;
  image?: string | undefined;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const clippedDescription = _.truncate(description, { length: 30 });
  const isDescriptionClipped = description.length > 30;

  return (
    <Main>
      <ProfilePicture
        src={image && image !== "none" ? image : "/images/ui/avatar.png"}
      />
      <Spacer size={10} direction="bottom" />
      <Name>{name}</Name>
      <Description
        $expandable={isDescriptionClipped}
        onClick={() => {
          if (isDescriptionClipped) setIsExpanded(!isExpanded);
        }}
      >
        {isExpanded ? description : clippedDescription}
      </Description>
    </Main>
  );
};

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 20rem;
  min-width: min(100%, 20rem);
  max-width: 100%;
  color: ${colors.white.hex};
`;

const ProfilePicture = styled.img`
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  border: 2px solid ${colors.complement.hex};
  cursor: pointer;
`;

const Name = styled.h3`
  font-size: 1.8rem;
  color: ${colors.text.hex};
  font-weight: 600;
`;

const Description = styled.p<{
  $expandable: boolean;
}>`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${colors.text.hex};
  opacity: 0.7;
  cursor: ${({ $expandable }) => ($expandable ? "pointer" : "default")};
  text-align: center;
`;
